import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideAuth,
  authInterceptor,
  withAppInitializerAuthCheck,
} from 'angular-auth-oidc-client';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { authConfig } from './services/auth/auth.config';
import { authErrorInterceptor } from './core/interceptors/auth-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([authInterceptor(), authErrorInterceptor]),
    ),
    provideAuth(authConfig, withAppInitializerAuthCheck()),
    provideToastr({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      tapToDismiss: true,
      extendedTimeOut: 1000,
    }),
  ],
};
